import { Pipe, PipeTransform } from '@angular/core';
import { OrderData, Quote } from '@zero/shared/util-models';

@Pipe({
  name: 'combinedMarketOrderValue',
  standalone: true,
})
export class CombinedMarketOrderValuePipe implements PipeTransform {
  public transform(order: OrderData, quote: Quote): number {
    if (!order || !quote) {
      return 0;
    }

    const { quantity, minimumQuantitySurcharge = 0, direction } = order;
    const isBuy = direction === 'buy';
    const price = isBuy ? quote.ask : quote.bid;
    const surcharge = isBuy ? minimumQuantitySurcharge : -minimumQuantitySurcharge;

    return quantity * price + surcharge;
  }
}
